export default __webpack_public_path__ + "static/media/vision-section-02.32249aac.png";